module.exports = __webpack_public_path__ + "img/omanalytics.94c5149f.png";